module.exports = __webpack_public_path__ + "static/media/faded-radial-gradients-background.6a3a2769.png";